import type { ExtensionConfig } from '@goto/shell-common'

const analyticsBaseUrl = '/experiences/analytics/'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-analytics',
  url: new URL(`${analyticsBaseUrl}@ucc/cc-analytics-extension.mjs`, location.origin),
  esModule: true,
  integrations: {
    msTeams: {
      shouldLoadInIntegration: true,
    },
    sidePanel: {
      shouldLoad: true,
    },
  },
  standaloneRoutes: ['/analytics']
}

export default extensionConfig
